module.exports = __webpack_public_path__ + "media/images/favicon/favicon-dffbf61c4a46cee66b2e9dee83fb7f4c9adc51c79ef2fd580b81fc664a3855a0.png";